import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  computed,
  effect,
  input,
  model,
} from '@angular/core';
import { BaseConfig } from '../common/config/config.adapter';
import { Icon } from '../icon/icon.component';

export type TabOption = {
  label: string;
  value: string;
  icon?: string;
};

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  standalone: true,
  imports: [CommonModule, Icon],
})
export class Tabs extends BaseConfig implements OnInit {
  value = model<string>();
  $options = input<string[] | TabOption[]>([], { alias: 'options' });

  options = computed<TabOption[]>(() => {
    if (this.$options().length === 0) return [];

    return this.$options().map((option) => {
      if (typeof option === 'string') {
        return {
          label: option,
          value: option,
        };
      }

      return option;
    });
  });

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (!this.value()) {
      this.value.set(this.options()[0]?.value);
    }
  }
}
